"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var FlagsContext = react_1.createContext(undefined);
exports.default = FlagsContext;
//# sourceMappingURL=FlagsContext.js.map